<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Resource Family Placements:</h4>
                <div>
                    <FosterFamilyAssignmentEditor :fields="[{name: 'Name', title: 'NAME'}, {name: 'StartDate', title: 'PLACEMENT', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'END', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                                  :field-data="ChildRecordData.ResourceFamilies"
                                                  :edit-mode="EditMode"
                                                  select-label="Resource Family:"
                                                  options-type="API"
                                                  options-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/GetAvailablePlacements"
                                                  :options-method-record-id="ChildRecordData.ClientProgramMembership.Id"
                                                  add-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/AssignFirstPlacement"
                                                  add-record-record-property-name="FosterResourceFamilyID"
                                                  :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                                  add-record-modal-title="Add First Placement"
                                                  transfer-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/TransferPlacement"
                                                  transfer-record-record-property-name="FosterResourceFamilyID"
                                                  :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                                  transfer-record-modal-title="Transfer Placement"
                                                  transfer-record-effective-date-property-name="StartDate"
                                                  delete-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/DeleteCurrentPlacement"
                                                  :delete-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                                  delete-record-modal-title="Delete Current Placement"
                                                  delete-record-modal-text="NOTICE: You are about to delete this child's current placement.  If there was a previous placement, it will re-open that placement."
                                                  :is-caregiver-support="IsCaregiverSupport" />
                </div>
            </div>

        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Case Managers:</h4>
                <div>
                    <SingleMembershipEditor :fields="[{name: 'Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="ChildRecordData.CaseManagers"
                                            :edit-mode="EditMode"
                                            select-label="Case Manager:"
                                            options-type="API"
                                            options-method="Core/EmployeeCaseload/GetAvailableCMEmployees"
                                            options-method-record-name="ClientSubProgramMembershipID"
                                            :options-method-record-id="ChildRecordData.ClientProgramMembership.Id"
                                            add-record-method="Core/EmployeeCaseload/AddClientToEmployeeCaseload"
                                            add-record-record-property-name="EmployeeID"
                                            :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id,
                                                                             EmployeeRole: 'Case Manager'}"
                                            add-record-modal-title="Add Initial Case Manager"
                                            transfer-record-method="Core/EmployeeCaseload/TransferCMMembership"
                                            transfer-record-record-property-name="EmployeeID"
                                            :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id,
                                                                                  EmployeeRole: 'Case Manager'}"
                                            transfer-record-modal-title="Transfer Case Managers"
                                            transfer-record-effective-date-property-name="StartDate"
                                            delete-record-method="Core/EmployeeCaseload/DeleteCurrentCMMembership"
                                            :delete-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.ClientProgramMembership.Id}"
                                            delete-record-modal-title="Delete Current Case Manager"
                                            delete-record-modal-text="NOTICE: You are about to delete this child's current Case Manager.  If there was a previous Case Manager assigned, the child will be re-assigned to them." />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Professionals:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Professionals/GetContacts"
                                           :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Professionals/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Professionals/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Professionals"
                                           :relationship-options="ProfessionalOptions"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :professional-dropdown-enabled="true"
                                           professional-dropdown-enabled-endpoint="Core/Clients/Contacts/Professionals/GetAllContactsInSubProgram"
                                           :professional-dropdown-enabled-payload="{Id: ChildRecordData.ClientProgramMembership.SubProgramID}"
                                           :display-agency="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Siblings with Olive Crest:</h4>
                <div>
                    <SiblingTable :edit-mode="EditMode"
                                  :ClientSubProgramMembershipID="ChildRecordData.Id" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Biological Family:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/BiologicalFamily/GetContacts"
                                           :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/BiologicalFamily/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                           delete-endpoint="Core/Clients/Contacts/BiologicalFamily/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Biological Family"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Child"
                                           :display-age="true"
                                           :display-relationship="true"
                                           :agency-input="false"
                                           :display-agency="false" />
                </div>
            </div>
        </div>
        <!--<div class="row record-section-row">
        <div class="col">
            <h4>Church Relationships:</h4>
            <div>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/ChildAbuseStopsHere/GetContacts"
                                       :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                       add-edit-endpoint="Core/ChildAbuseStopsHere/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                       delete-endpoint="Core/ChildAbuseStopsHere/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Church Relationship"
                                       :relationship-options="null"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :church-input="true"
                                       :display-church="true" />
            </div>
        </div>
    </div>-->
        <div class="row record-section-row">
            <div class="col">
                <h4>Informal Relationships:</h4>
                <div>
                    <InformalRelationshipsDisplayAndEdit :edit-mode="EditMode"
                                                         :chart-id="ChildRecordData.ClientProgramMembership.Id"
                                                         :client-first-name="ChildRecordData.Client.Person.FirstName" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Misc:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Misc/GetContacts"
                                           :get-payload="{Id: ChildRecordData.ClientProgramMembership.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Misc/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.ClientProgramMembership.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Misc/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Misc"
                                           :relationship-options="null"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Respites:</h4>
                <div>
                    <RespiteEditor :client-sub-program-membership-id="ChildRecordData.Id" :edit-mode="EditMode" :can-edit="true" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SiblingTable from '../../../Core/RecordComponents/SiblingTable';
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';
    import ContactDisplayAndEdit from '../../../Core/ItemEditors/ContactDisplayAndEdit.vue';
    import FosterFamilyAssignmentEditor from '../../../Core/ItemEditors/FosterFamilyAssignmentEditor.vue';
    import InformalRelationshipsDisplayAndEdit from '../../../Core/ItemEditors/InformalRelationshipsDisplayAndEdit.vue';
    import RespiteEditor from './RespiteEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            SingleMembershipEditor,
            ContactDisplayAndEdit,
            FosterFamilyAssignmentEditor,
            EditMode,
            SiblingTable,
            InformalRelationshipsDisplayAndEdit,
            RespiteEditor
        },
        mounted() {

        },
        computed: {
            GetSubProgramTerminationReasons: function () {
                let subprogram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ChildRecordData.ClientProgramMembership.SubProgramID);
                let returnObj = [];
                if (subprogram.DischargeReasons.length > 0) {
                    subprogram.DischargeReasons.forEach(function (item) {
                        returnObj.push({ text: item.Label, value: item.Id });
                    })
                }
                return returnObj;
            },
            ProfessionalOptions: function () {
                return this.$store.state.Options.ProfessionalTypes;
            },
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            },
            IsCaregiverSupport: function () {
                let caregiverSupportSubProgramIDs = ['D9B74D70-B9B0-411C-BC1B-90B608036062',
                    'EACF40B6-EF88-41D0-BE4B-6D4F64950865',
                    '33E864F6-20F5-46A2-B586-1FD174DEFBFA',
                    '130F6819-F937-41A7-8FC0-29E052E1F6CC',
                    '12943A82-3156-4270-91A3-63200C6C4AE9',
                    '3F28D8CE-4CD8-4CC4-9984-9AE0BD645DA0'].map(id => id.toUpperCase());

                let subProgramID = this.ChildRecordData
                    && this.ChildRecordData.ClientProgramMembership
                    && this.ChildRecordData.ClientProgramMembership.SubProgramID;

                return !!subProgramID && caregiverSupportSubProgramIDs.includes(subProgramID.toUpperCase());
            }
        }    
    }
</script>

<style scoped>
</style>